import axios from "axios";
import { API_ENDPOINTS } from "config/config";
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const GlobalSettingContext = createContext(null);

export function GlobalSettingProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const token = localStorage.getItem("authToken");

  const fetchSettings = async () => {
    try {
      const res = await axios.get(API_ENDPOINTS.GET_SETTINGS, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res?.data?.data) {
        const {
          _id,
          isShowDeletedRecords,
          salesRecordBy,
          expenseRecordBy,
        } = res.data.data;
        setSettings({
          _id,
          isShowDeletedRecords,
          salesRecordBy,
          expenseRecordBy,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const value = { settings, setSettings, fetchSettings };

  return (
    <GlobalSettingContext.Provider value={value}>
      {children}
    </GlobalSettingContext.Provider>
  );
}


export const useSettings = () => {
  const context = useContext(GlobalSettingContext);

  if (!context) {
    throw new Error("useSettings must be used within a GlobalSettingProvider");
  }

  return context;
};
